import styles from '@components/Dot.module.css';

type Props = {
  color?:
    | 'secondary300'
    | 'tagOrange'
    | 'accentEggplant'
    | 'accentSky'
    | 'error500'
    | 'error300'
    | 'error450'
    | 'neutral50'
    | 'neutral100'
    | 'neutral700'
    | 'primary50'
    | 'primary300'
    | 'primary500'
    | 'primary700'
    | 'secondary500'
    | 'secondary700'
    | 'success500'
    | 'shadesBlack'
    | 'shadesWhite'
    | 'tagGreen'
    | 'tagOrange'
    | 'neutral300';

  size?: 'medium' | 'small';
  unread: boolean;
};

const Dot = ({ color = 'secondary300', size = 'small', unread }: Props) => {
  if (unread) {
    return (
      <div
        className={`${styles.dot} ${size === 'medium' ? styles.medium : styles.small} ${styles[color]}`}
        data-test="unread"
      />
    );
  }
  return null;
};

export default Dot;
